import { Component, OnInit } from '@angular/core';
import { Routes } from 'src/app/models/routes.enum';

@Component({
  selector: 'app-bouton-retour-coordonnees',
  templateUrl: './bouton-retour-coordonnees.component.html',
  standalone: false,
})
export class BoutonRetourCoordonneesComponent implements OnInit {
  urlCoordonnees: string;

  constructor() {}

  ngOnInit() {
    this.urlCoordonnees = Routes.COORDONNEES;
  }
}
